// src/Layout.js
import React, { useState, useEffect, useCallback } from "react";
// import Margin from "./universal/Margin";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import TubelightNavbar from "./components/ui/TubelightNavbar";
import ResponsiveFooter from "./universal/footer/ResponsiveFooter";
import "./universal/Navbar.css";

export default function Layout() {
  // Promotion bar logic (from old Navbar.js)
  const [isPromotionVisible, setIsPromotionVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll detection for transparency
  const handleScroll = useCallback(() => {
    const currentScrollTop = window.scrollY;
    setIsScrollingDown(currentScrollTop > lastScrollTop);
    setLastScrollTop(currentScrollTop);
  }, [lastScrollTop]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  // Promotion bar sizing
  const updateContentTopMargin = useCallback(() => {
    const promotionBarHeight = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--promotion-bar-height");
    const navbarHeight = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--navbar-height");
    document.documentElement.style.setProperty(
      "--content-top-margin",
      `calc(${promotionBarHeight} + ${navbarHeight})`
    );
  }, []);

  const updatePromotionBarHeight = useCallback(() => {
    const promotionBar = document.querySelector(".promotion-bar");
    const promotionBarHeight = promotionBar?.offsetHeight || 0;
    if (window.innerWidth <= 1092) {
      document.documentElement.style.setProperty(
        "--promotion-bar-height-mobile",
        `${promotionBarHeight}px`
      );
    } else {
      document.documentElement.style.setProperty(
        "--promotion-bar-height",
        `${promotionBarHeight}px`
      );
      document.documentElement.style.setProperty(
        "--promotion-bar-height-mobile",
        "0px"
      );
    }
    updateContentTopMargin();
  }, [updateContentTopMargin]);

  useEffect(() => {
    updatePromotionBarHeight();
    window.addEventListener("resize", updatePromotionBarHeight);
    return () => window.removeEventListener("resize", updatePromotionBarHeight);
  }, [isPromotionVisible, updatePromotionBarHeight]);

  const promotionBarClassName = `promotion-bar ${
    isScrollingDown && !isHovered ? "transparent" : ""
  } promotion-bar-bootcamps`;

  return (
    <>
      <TubelightNavbar className="tubelight-navbar-fullwidth" />
      {/* Content starts from the top edge, navbar is fixed on top */}
      {/* {location.pathname !== "/" && <Margin />} */}
      <main>
        
        <Outlet />
      </main>
      <ResponsiveFooter />
    </>
  );
}
